import BaseService from '@/services/services/tools/baseService';
import treatsEntities from '@/business/apiTreatment/response/entities';
import EntitiesAPI from '@/services/api/internal/entities.api';

const EntitiesService = new BaseService({
  api: EntitiesAPI,
  treatListResponse: treatsEntities,
});

export default EntitiesService;
